import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MzicSvgComponent } from '@mzic/mzic-components';
import { CpfValidator } from '../../../utils/cpf-validator';

@Component({
  selector: 'lib-waiver-cpf-field',
  imports: [CommonModule, ReactiveFormsModule, A11yModule, MzicSvgComponent],
  templateUrl: './waiver-cpf-field.component.html',
  styleUrl: './waiver-cpf-field.component.scss',
})
export class WaiverCpfFieldComponent {
  @Input({ required: true }) control!: FormControl<string>;
  @Input({ required: true }) sectionTitle!: string;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) placeholder!: string;
  @Input({ required: true }) invalidError!: string;
  @Input() privacyInfo: string | null = null;
  @Input() initialFocus = false;

  get isInvalidCpf(): boolean {
    const value = this.control.value;
    const unformatted = CpfValidator.unformat(value);
    return (
      this.control.touched &&
      unformatted.length === 11 &&
      !CpfValidator.validate(value)
    );
  }

  onCpfInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const formatted = CpfValidator.format(input.value);
    this.control.setValue(formatted, { emitEvent: false });
    input.value = formatted;
  }
}
